import { render, staticRenderFns } from "./kickOut.vue?vue&type=template&id=5e01ce42"
import script from "./kickOut.vue?vue&type=script&lang=ts"
export * from "./kickOut.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports